import { Action } from "@ngrx/store";
import { EdcMachine } from "@tendercuts/models/store/edc-machine";

import { GenericError, Store, StoreConfig } from "@tendercuts/models";

/**
 * Action to trigger the server request
 */
export class ActionLoadStores implements Action {
  readonly type = "ACTION_LOAD_STORES";

  constructor(public userStoreId: string) {}
}

/**
 * Action trigger on store load success
 */
export class ActionStoresLoadSuccess implements Action {
  readonly type = "ACTION_STORES_LOAD_SUCCESS";

  constructor(public stores: Store[]) {}
}

/**
 * Action triggered if stores load fails
 */
export class ActionStoresLoadFailed implements Action {
  readonly type = "ACTION_STORES_LOAD_FAIL";

  constructor(public error: GenericError) {}
}

/**
 * Action triggered to store the current store detail
 */
export class ActionSetCurrentStore implements Action {
  readonly type = "ACTION_SET_CURRENT_STORE";

  constructor(public store: Store) {}
}


/**
 * Action to trigger the server request to load edc machines
 */
 export class ActionLoadStoreEdcMachines implements Action {
  readonly type = "ACTION_LOAD_STORE_EDC_MACHINES";

  constructor(public userStoreId: string) {}
}


/**
 * Action to trigger the server request for store config
 */
 export class ActionLoadStoreConfig implements Action {
  readonly type = "ACTION_LOAD_STORE_CONFIG";

  constructor(public userStoreId: string) {}
}


/**
 * Action triggered to store the current store edc machines
 */
export class ActionSetCurrentStoreEdcMachines implements Action {
  readonly type = "ACTION_SET_CURRENT_STORE_EDC_MACHINES";

  constructor(public edcMachines: EdcMachine[]) {}
}


/**
 * Action trigger on edc machines load success
 */
 export class ActionStoresLoadEdcMachinesSuccess implements Action {
  readonly type = "ACTION_STORES_LOAD_EDC_MACHINES_SUCCESS";

  constructor(public edcMachine: EdcMachine[]) {}
}

/**
 * Action triggered if edc machines load fails
 */
export class ActionStoresLoadEdcMachinesFailed implements Action {
  readonly type = "ACTION_STORES_LOAD_EDC_MACHINES_FAIL";

  constructor(public error: GenericError) {}
}

/**
 * Action triggered update selected edc machine
 */
export class ActionUpdateSelectedEdcMachine implements Action {
  readonly type = "ACTION_UPDATE_SELECTED_EDC_MACHINE";
  constructor(public selectedEdcMachine: EdcMachine) { }
}

/**
 * Action triggered update selected edc machine success
 */
export class ActionUpdateSelectedEdcMachineDone implements Action {
  readonly type = "ACTION_UPDATE_SELECTED_EDC_MACHINE_DONE";
  constructor() { }
}
/**
 * Action trigger on store config load success
 */
 export class ActionLoadStoreConfigSuccess implements Action {
  readonly type = "ACTION_STORE_LOAD_CONFIG_SUCCESS";

  constructor(public storeConfig: StoreConfig[]) {}
}

/**
 * Action triggered if store config load fails
 */
 export class ActionLoadStoreConfigFailed implements Action {
  readonly type = "ACTION_STORES_LOAD_CONFIG_FAIL";

  constructor(public error: GenericError) {}
}
